<template>
  <BaseCenteredModal v-model:is-modal-open="localIsModalOpen" size="medium">
    <template #body>
      <div class="flex w-full flex-col gap-3">
        <div v-if="form === 'starting_form' || form === 'ending_form'">
          <div
            v-for="(question, index) in this.form === 'starting_form'
              ? gWorkTask.starting_form
              : gWorkTask.ending_form"
            :key="index"
            class="grid h-32 grid-cols-3 overflow-visible"
          >
            <DynamicFormInput
              :question="question"
              :questionIndex="index"
              @questionValue="getQuestionValue"
              class="overflow-visible"
            />
          </div>
        </div>
        <div v-else>
          <BaseInput
            class="col-start-2"
            :label="$t('attributes.awaiting_reason')"
            :placeholder="$t('attributes.awaiting_reason')"
            name="awaiting_reason"
            :disabled="permission"
            :required="true"
            v-model="gWorkTask.awaiting_reason"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <BaseButton
        :title="$t('button.confirm')"
        icon="paper-plane"
        color="primary"
        @click="submitForm"
      />
      <BaseButton :title="$t('button.close')" color="dark" @click="close" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'

export default {
  name: 'WorkTaskStatusChangeDialog',
  components: { BaseCenteredModal },
  emits: ['close', 'backdropClicked'],
  props: {
    task: {},
    form: {},
    nextStatus: {},
    isModalVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      test: [
        { type: 'input', options: [], question: 'ah ?' },
        { type: 'textArea', options: [], question: 'oh ?' },
        {
          type: 'select',
          options: [
            { id: 1, name: 'un' },
            { id: 2, name: 'deux' }
          ],
          question: 'oui'
        },
        {
          type: 'radio',
          options: [
            { id: 1, name: 'un' },
            { id: 2, name: 'deux' }
          ],
          question: 'oui'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({ gWorkTask: 'work/getSelectedWorkTask' }),
    localIsModalOpen: {
      get() {
        return this.isModalVisible
      },
      set(value) {
        if (!value) this.close()
      }
    },
    permission() {
      return !this.$can('manage_work')
    }
  },
  methods: {
    ...mapActions({
      updateWorkTask: 'work/updateWorkTask',
      updateWorkTaskStatus: 'work/updateWorkTaskStatus'
    }),
    ...mapMutations({
      alterWorkTaskQuestionValue: 'work/alterWorkTaskQuestionValue'
    }),
    getQuestionValue({ attribute, value, index }) {
      this.alterWorkTaskQuestionValue({
        form: this.form,
        index: index,
        value: value
      })
    },
    getInputValue({ attribute, value }) {
      this.gWorkTask.awaiting_reason = value
    },
    submitForm() {
      // this.$h.toastSuccess('submit form called successfully')
      this.updateWorkTask({
        id: this.gWorkTask.id,
        task: this.gWorkTask
      }).then(() => {
        this.updateWorkTaskStatus({
          id: this.gWorkTask.id,
          new_status: this.nextStatus
        }).then(() => {
          this.$h.toastSuccess(
            this.$t('toasts.updated_f', {
              var: this.$t('attributes.task')
            })
          )
        })
        this.close()
      })
    },
    close() {
      this.$emit('close')
    }
  },
  watch: {}
}
</script>
